export function SoundRecognitionSearch({ className }: { className?: string }) {
    return (
      <svg
        className={className}
        width="1em"
        height="1em"
        viewBox="0 0 94 94"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Sound-Recognition-Search--Streamline-Core.svg">
          <g id="sound-recognition-search">
            <path
              id="vector"
              d="M62.5872 81.2919C72.9178 81.2919 81.2919 72.9178 81.2919 62.5872C81.2919 52.257 72.9178 43.8826 62.5872 43.8826C52.257 43.8826 43.8826 52.257 43.8826 62.5872C43.8826 72.9178 52.257 81.2919 62.5872 81.2919Z"
              stroke="currentcolor"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="vector_2"
              d="M87.5267 87.5267L75.8132 75.8132"
              stroke="currentcolor"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="vector_3"
              d="M22.0603 6.47314V62.5871"
              stroke="currentcolor"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="vector_4"
              d="M6.47314 22.0603V46.9998"
              stroke="currentcolor"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="vector_5"
              d="M53.2349 6.47314V31.4127"
              stroke="currentcolor"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="vector_6"
              d="M37.6475 22.0603V40.765"
              stroke="currentcolor"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </svg>
    );
  }
  